<template>
  <div class="pt-3">
    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <Loader v-if="loading"/>

    <div
      v-if="userCanAddResult"
      class="mb-3">
      <button type="button" class="btn btn-primary" @click="showAddForm">
        Добавить результат анализа
      </button>
    </div>

    <Form
      v-if="(userCanAddResult || userCanEditResult) && showForm === true"
      :client="client"
      :tests="tests"
      :result="result"
      v-on:create-result="createResult"
      v-on:update-result="updateResult"
      v-on:delete-result="deleteResult"
      v-on:cancel="closeForm"/>

    <div v-if="results.length === 0 && loading === false">
      Пока нет результатов анализов
    </div>

    <Calendar
      :client="client"
      :results="results"
      v-on:update-result="showUpdateForm"/>
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import Calendar from './test/Calendar';
import Form from './test/Form';

export default {
  name: 'ClientTest',

  components: {Loader, Flash, Calendar, Form},

  props: ['client'],

  data() {
    return {
      loading: false,
      error: '',
      success: '',
      showForm: false,
      resultId: null,
    };
  },

  created() {
    this.loadUserData();
    this.loadTestData();
  },

  computed: {
    results() {
      return this.$store.getters.getTestClientResults(this.client.id);
    },

    result() {
      return this.results.find(result => result.id === this.resultId);
    },

    tests() {
      return this.$store.state.test.tests;
    },

    userCanAddResult() {
      return this.$security.voters.test.canAddResult(this.$store.state.user);
    },

    userCanEditResult() {
      return this.$security.voters.test.canEditResult(this.$store.state.user);
    },
  },

  methods: {
    async loadUserData() {
      try {
        this.loading = true;

        await this.$store.dispatch('TEST_LOAD_RESULTS', this.client.id);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async loadTestData() {
      try {
        await Promise.all([
          this.$store.dispatch('TEST_LOAD_TESTS')
        ]);
      } catch (e) {
        this.error = e.message;
      }
    },

    showUpdateForm(id) {
      if (!this.userCanEditResult) {
        return;
      }

      this.resultId = id;
      this.showForm = true;
    },

    showAddForm() {
      this.resultId = null;
      this.showForm = true;
    },

    closeForm() {
      this.resultId = null;
      this.showForm = false;
    },

    async updateResult(data) {
      try {
        this.loading = true;

        const {test, value, date, result} = data;
        const params = {
          client: this.client.id,
          id: result.id,
          data: {value, date}
        };
        const testObj = this.tests.find(t => t.id === test);

        if (typeof testObj === 'undefined') {
          throw new Error(`Анализ ${test} не найден`);
        }

        await this.$store.dispatch('TEST_UPDATE_RESULT', params);

        this.success = `Результат успешно обновлен. Анализ: ${testObj.name}, значение: ${value}`;
      } catch (e) {
        this.error = e.message;
      }

      this.closeForm();
      this.loading = false;
    },

    async createResult(data) {
      try {
        this.loading = true;

        const {test, value, date} = data;
        const params = {client: this.client.id, test, value, date};
        const testObj = this.tests.find(t => t.id === test);

        if (typeof testObj === 'undefined') {
          throw new Error(`Анализ ${test} не найден`);
        }

        await this.$store.dispatch('TEST_ADD_RESULT', params);

        this.success = `Результат успешно добавлен. Анализ: ${testObj.name}, значение: ${value}`;
      } catch (e) {
        this.error = e.message;
      }

      this.closeForm();
      this.loading = false;
    },

    async deleteResult(id) {
      this.loading = true;

      const params = {client: this.client.id, id};

      try {
        this.closeForm();

        await this.$store.dispatch('TEST_DELETE_RESULT', params);

        this.success = 'Результат анализа успешно удален';
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
